export const REMITTANCE_DATA_LOADING = "app/REMITTANCE_DATA_LOADING";
export const REMITTANCE_DATA_RESULTS = "app/REMITTANCE_DATA_RESULTS";
export const CHANGE_PAGE = "app/CHANGE_PAGE";
